import React from 'react';

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  ({ active = false, className = '', children, ...props }, ref) => {
    const baseStyles =
      'aspectly:px-4 aspectly:py-1.5 aspectly:rounded-full aspectly:text-xs aspectly:font-bold aspectly:cursor-pointer aspectly:transition-colors';
    const activeStyles = active
      ? 'aspectly:bg-primary aspectly:text-on-primary' : 'aspectly:hover:bg-surface-container-low aspectly:text-on-surface-variant';

    return (
      <button ref={ref} className={`${baseStyles} ${activeStyles} ${className}`} {...props}>
        {children}
      </button>
    );
  },
);
Chip.displayName = 'Chip';
